
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rims/transportbil/mercedes-sprinter",
      function () {
        return require("private-next-pages/rims/transportbil/mercedes-sprinter.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rims/transportbil/mercedes-sprinter"])
      });
    }
  